import { type Guard } from '@capsicum/common';
import { useRouter } from '@capsicum/common-web';
import { useChooseYourTeamsGuardStatus } from '@capsicum/socios-core';
import { useCallback } from 'react';

export const useChooseYourTeamsGuard: Guard = () => {
	const { replace } = useRouter();

	return {
		onDenied: useCallback(() => replace('/home'), [replace]),
		status: useChooseYourTeamsGuardStatus()
	};
};
